// Sección de Inicio "Noches especiales que ya viví": invita a la página de eventos.
import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { eventos, seccionEventosInicio } from '../../data/eventos';
import { eventoPorId, RUTA_EVENTOS, rutaEvento } from '../../services/eventos';
import useEnVista from '../../hooks/useEnVista';
import { alIntentar, Enfasis, Estrellas, Fuego, NombreEvento, PilaPulseras, Pieza, Polaroid } from './Piezas';
import './Eventos.css';

/** Lugar de sus 2 fotos. @type {import('./Piezas').Lugar[]} */
const FOTOS = [
  { d: [5, 2.9, 38.3, -6], m: [1.7, 0, 34.3, -6] },
  { d: [43.3, 14.7, 50, 5], m: [40, 5.3, 51.4, 5] }
];

export default function EventosInicio() {
  const ref = useRef(null);
  const visible = useEnVista(ref);
  const s = seccionEventosInicio;
  return (
    <section id="eventos-disney" ref={ref} className={`ev-inicio sec on-dark ev-anim${visible ? '' : ' ev-pausa'}`} aria-label="Eventos Disney">
      <Estrellas n={40} semilla={91} />
      <Fuego x="89%" y="12%" color="var(--acc)" retraso={-0.5} largo={40} className="ev-solo-escritorio" />
      <Fuego x="62%" y="17%" color="#EF5DA8" retraso={-2} largo={32} className="ev-solo-escritorio" />
      <div className="wrap ev-inicio__in">
        <div className="ev-inicio__txt" data-reveal>
          <p className="eyebrow">Eventos Disney</p>
          <h2 className="h2"><Enfasis texto={s.titulo} /></h2>
          <p className="lead">{s.lead}</p>
        </div>
        <div className="ev-inicio__visual" aria-hidden="true">
          <div className="ev-abanico ev-abanico--inicio">
            {s.fotos.map((f, i) => {
              const ev = eventoPorId(f.evento);
              if (!ev) return null;
              return (
                <Pieza key={f.src} lugar={FOTOS[i]} flota retraso={-1 - 2 * i}>
                  <Link to={rutaEvento(ev)} className="ev-enlace-foto" tabIndex={-1} {...alIntentar(ev)}><Polaroid foto={f} /></Link>
                </Pieza>
              );
            })}
          </div>
          <PilaPulseras />
        </div>
        <div className="ev-inicio__acciones">
          <div className="ev-inicio__lista">
            {eventos.map((e) => (
              <Link key={e.id} to={rutaEvento(e)} className="ev-inicio__evento" {...alIntentar(e)}>
                <span><span className="ev-punto" style={{ background: e.tema.banda }} /><span><NombreEvento evento={e} /></span></span>
                <em>{e.anio}</em>
              </Link>
            ))}
          </div>
          <Link to={RUTA_EVENTOS} className="ev-btn-oro">Ver los eventos<i className="fa-solid fa-arrow-right" /></Link>
        </div>
      </div>
    </section>
  );
}
